import { z } from 'zod';

export const apiErrorCodeSchema = z.enum([
  'NOT_FOUND',
  'FORBIDDEN',
  'UNAUTHORIZED',
  'CONFLICT',
  'VALIDATION',
  'NOT_APPROVED',
  'NOT_ACCEPTING_ORDERS',
  'FULFILLMENT_NOT_AVAILABLE',
  'OUT_OF_DELIVERY_AREA',
  'PLATFORM_DELIVERY_NOT_AVAILABLE',
  'OUTSIDE_OPENING_HOURS',
  'CURRENCY_MISMATCH',
  'PAYOUT_SCHEDULE_TOO_FREQUENT',
  'PAYOUT_TOO_RECENT',
  'DISPUTE_WINDOW_CLOSED',
  'DISPUTE_NOT_AWAITING_RESTAURANT',
  'PLATFORM_GOODWILL_NOT_ALLOWED_FOR_RESTAURANT',
  'ORDER_NOT_REVIEWABLE',
  'REVIEW_WINDOW_CLOSED',
  'REVIEW_ALREADY_SUBMITTED',
  'REVIEW_NOT_FOUND',
  'INVALID_TRANSITION',
  'ORDER_NOT_CANCELLABLE',
  'PRICING_MISMATCH',
  'IDEMPOTENCY_CONFLICT',
  'PAYMENT_FAILED',
  'IMAGE_VERIFICATION_FAILED',
  'NOT_IMPLEMENTED',
]);
export type ApiErrorCode = z.infer<typeof apiErrorCodeSchema>;

export const HTTP_STATUS_BY_CODE: Readonly<Record<ApiErrorCode, number>> = {
  NOT_FOUND: 404,
  FORBIDDEN: 403,
  UNAUTHORIZED: 401,
  CONFLICT: 409,
  VALIDATION: 422,
  NOT_APPROVED: 409,
  NOT_ACCEPTING_ORDERS: 409,
  FULFILLMENT_NOT_AVAILABLE: 409,
  OUT_OF_DELIVERY_AREA: 409,
  PLATFORM_DELIVERY_NOT_AVAILABLE: 501,
  OUTSIDE_OPENING_HOURS: 409,
  CURRENCY_MISMATCH: 409,
  PAYOUT_SCHEDULE_TOO_FREQUENT: 422,
  PAYOUT_TOO_RECENT: 409,
  DISPUTE_WINDOW_CLOSED: 409,
  DISPUTE_NOT_AWAITING_RESTAURANT: 409,
  PLATFORM_GOODWILL_NOT_ALLOWED_FOR_RESTAURANT: 422,
  ORDER_NOT_REVIEWABLE: 409,
  REVIEW_WINDOW_CLOSED: 409,
  REVIEW_ALREADY_SUBMITTED: 409,
  REVIEW_NOT_FOUND: 404,
  INVALID_TRANSITION: 409,
  ORDER_NOT_CANCELLABLE: 409,
  PRICING_MISMATCH: 409,
  IDEMPOTENCY_CONFLICT: 409,
  PAYMENT_FAILED: 502,
  IMAGE_VERIFICATION_FAILED: 409,
  NOT_IMPLEMENTED: 501,
};

export const apiErrorBodySchema = z.object({
  code: z.string(),
  message: z.string().optional(),
  issues: z.array(z.unknown()).optional(),
  /** `POST /v1/restaurants/:id/submit-for-review` when `validateSubmissionCompleteness` fails. */
  missing: z.array(z.string()).optional(),
});
export type ApiErrorBody = z.infer<typeof apiErrorBodySchema>;
